import React from 'react';

function LinkedinSvg({ className }) {
  return (
    <svg
      className={className}
      width="96"
      height="58"
      viewBox="0 0 96 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65.4211 30.8945C72.2888 30.8945 78.8752 33.6227 83.7315 38.4789C88.5877 43.3351 91.3158 49.9216 91.3158 56.7893V86.9998H74.0527V56.7893C74.0527 54.5 73.1433 52.3046 71.5246 50.6858C69.9058 49.0671 67.7103 48.1577 65.4211 48.1577C63.1319 48.1577 60.9364 49.0671 59.3177 50.6858C57.6989 52.3046 56.7895 54.5 56.7895 56.7893V86.9998H39.5264V56.7893C39.5264 49.9216 42.2546 43.3351 47.1108 38.4789C51.967 33.6227 58.5534 30.8945 65.4211 30.8945Z"
        stroke="#F7F6F6"
        strokeWidth="8.63158"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2632 35.2109H5V87.0004H22.2632V35.2109Z"
        stroke="#F7F6F6"
        strokeWidth="8.63158"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6316 22.2632C18.3987 22.2632 22.2632 18.3987 22.2632 13.6316C22.2632 8.86449 18.3987 5 13.6316 5C8.86449 5 5 8.86449 5 13.6316C5 18.3987 8.86449 22.2632 13.6316 22.2632Z"
        stroke="#F7F6F6"
        strokeWidth="8.63158"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LinkedinSvg;
